import { CS } from "../../../../base/utils/styler";

export const priceTdStyle: CS = {
    textAlign: 'right',
    fontSize: '18px',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row-reverse',
    justifyContent: 'flex-end',
}

export const oldValueStyle: CS = {
    textDecoration: 'line-through',
    color: '#ccc',
    marginRight: '8px',
    display: 'none'
}

export const editableStyle: CS = {
    minWidth: '50px',
    cursor: 'pointer',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    border: '1px solid transparent',
    padding: '5px',
    backgroundColor: 'white',
    zIndex: '0',
    borderRadius: '5px',
    display: 'inline-block',
    '&:hover': {
        borderColor: '#ccc',
    },
    '&:focus': {
        zIndex: 1,
        maxWidth: 'none',
        width: 'auto',
        whiteSpace: 'normal',
        borderColor: '#aaa',
        outline: 'none'
    }
}